export const VET_GROUP_SLUG = 'veterinarian-community';
